import { Avatar, Box, HStack } from '@chakra-ui/react';
import { useMyProfileModel } from '@common/models/MyProfileModel';
import * as React from 'react';
import { useSession } from 'src/apps/invest/common/hooks/useSession';
import { TextBlock } from '../components/TextBlock';

export const UserProfile = () => {
  const session = useSession();
  const myProfileModel = useMyProfileModel();
  return (
    <HStack spacing="3" ps="2">
      <Avatar name={session.session?.name} src={myProfileModel.myProfile?.headshot?.download_url ?? ''} boxSize="10" />
      <Box>
        <TextBlock fontWeight="medium" fontSize="sm">
          {session.session?.name}
        </TextBlock>
      </Box>
    </HStack>
  );
};
